exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-wandering-cubes {\n    top: 50%;\n    margin: auto;\n    width: 40px;\n    height: 40px;\n    position: relative;\n}\n\n.sk-wandering-cubes .sk-cube {\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: sk-wanderingCube 1.8s ease-in-out -1.8s infinite both;\n}\n\n.sk-wandering-cubes .sk-cube2 {\n    animation-delay: -0.9s;\n}\n\n@keyframes sk-wanderingCube {\n    0% {\n        transform: rotate(0deg);\n    }\n    25% {\n        transform: translateX(30px) rotate(-90deg) scale(0.5);\n    }\n    50% {\n        /* Hack to make FF rotate in the right direction */\n        transform: translateX(30px) translateY(30px) rotate(-179deg);\n    }\n    50.1% {\n        transform: translateX(30px) translateY(30px) rotate(-180deg);\n    }\n    75% {\n        transform: translateX(0) translateY(30px) rotate(-270deg) scale(0.5);\n    }\n    100% {\n        transform: rotate(-360deg);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/app/spinner/spinkit-css/sk-wandering-cubes.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-wandering-cubes.css
// module chunks = main